import { createFileRoute, notFound } from "@tanstack/react-router";
import homeStyles from "../styles/platform-home.css?url";
import authorsStyles from "../styles/platform-authors.css?url";
import { planCopy, regularMonth } from "../../src/lib/plan-copy";
import type { StructuredData } from "../../src/lib/structured-data";
import { withStylesheet } from "../lib/head";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { AuthorsPage } from "../platform/authors-page";
import { loadAuthorsPage } from "../platform/product-pages";

/**
 * Drate's page for authors and writers (/for-authors), where the "Your stories. Your platform.
 * Free." Instagram ad lands; a 404 on creator sites.
 */
export const Route = createFileRoute("/for-authors")({
  loader: async () => {
    const page = await loadAuthorsPage();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) => {
    if (!loaderData) return {};
    const shell = platformShellFrom(matches);
    const pick = planCopy(shell?.regular ?? false);
    return withStylesheet(
      withStylesheet(
        platformPageHead(shell, {
          pathname: "/for-authors",
          title: pick("Your own author platform, free | Drate", "Your own author platform | Drate"),
          description: pick(
            "Post chapters, grow your readers and earn from members on a site of your own. Free to start.",
            `Post chapters, grow your readers and earn from members on a site of your own. From ${regularMonth} a month.`,
          ),
          canonicalPath: "/for-authors",
          structuredData: JSON.parse(loaderData.structuredData) as StructuredData,
        }),
        homeStyles,
      ),
      authorsStyles,
    );
  },
  component: AuthorsPage,
});
